import React from 'react';
import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';

import { useExchangeConditions } from '@hooks/index';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { PlAN_TYPES } from '@constants/individualPortal/customGrouping/customGrouping.constants';

const StyledBenefitDetailsContainer = styled.div`
    .grid-body{
        div{
            span:nth-of-type(odd){
                flex: 4 1 0
            }
            span:nth-of-type(even){
                flex: 5 1 0
            }
        }
    }
`;

const BenefitDetails = (props: { enrollmentDetails: IEnrollmentDetails }) => {
    const { enrollmentDetails } = { ...props };
    const { isPrimaryCareVisitVisible } = useExchangeConditions();

    const getHealthPlanDetails = () => {
        return (
            <>
                <div>
                    <span><FormattedMessage id="indportal.portalhome.plantype" /></span>
                    <span>{enrollmentDetails.productType}</span>
                </div>
                <div>
                    <span><FormattedMessage id={isPrimaryCareVisitVisible ? 'indportal.enrollments.primaryCareVisit' : 'indportal.enrollments.officeVisit'} /></span>
                    <span dangerouslySetInnerHTML={{ __html: enrollmentDetails.officeVisit }}></span>
                </div>
                <div>
                    <span><FormattedMessage id="indportal.enrollments.genericMedications" /></span>
                    <span dangerouslySetInnerHTML={{ __html: enrollmentDetails.genericMedications }}></span>
                </div>
                <div>
                    <span><FormattedMessage id="indportal.enrollments.deductible" /></span>
                    <span>{enrollmentDetails.deductible}</span>
                </div>
                <div>
                    <span><FormattedMessage id="indportal.enrollments.outOfPocketMaximum" /></span>
                    <span>{enrollmentDetails.oopMax}</span>
                </div>
            </>
        );
    };

    const getDentalPlanDetails = () => {
        return (
            <>
                <div>
                    <span><FormattedMessage id="indportal.portalhome.plantype" /></span>
                    <span>{enrollmentDetails.productType}</span>
                </div>
                <div>
                    <span><FormattedMessage id="pd.label.title.routineDentalAdult" />:</span>
                    <span>{enrollmentDetails.routineDental}</span>
                </div>
                <div>
                    <span><FormattedMessage id="pd.label.title.dentalCheckupChild" />:</span>
                    <span>{enrollmentDetails.dentalCheckup}</span>
                </div>
                <div>
                    <span><FormattedMessage id="indportal.enrollments.dentalDeductible" /></span>
                    <span>{enrollmentDetails.deductible}</span>
                </div>
                <div>
                    <span><FormattedMessage id="indportal.enrollments.DentalOutOfPocketMaximum" /></span>
                    <span>{enrollmentDetails.oopMax}</span>
                </div>
            </>
        );
    };

    return (
        <StyledBenefitDetailsContainer className="col-xs-12 col-md-6 col-lg-6" data-testid="benefitSummary">
            <div className='gi-table gi-usa-table'>
                <div className='header-border'>
                    <span className='grid-header' data-testid="benefitSummaryHeader">
                        <FormattedMessage id="indportal.enrollments.benefitSummary" />
                    </span>
                </div>
                <div className='grid-body'>
                    {enrollmentDetails.planType.toUpperCase() === PlAN_TYPES.DENTAL ? getDentalPlanDetails() : getHealthPlanDetails()}
                </div>
            </div>
        </StyledBenefitDetailsContainer>
    );
};

export default BenefitDetails;